import React, { useRef, useCallback } from 'react';
import { useFrame } from '@react-three/fiber';
import { Billboard } from '@react-three/drei';
import * as THREE from 'three';
import { GUESTBOOK_Z } from './constants';

export default function GuestBookAltar({ onOpen, isNear }) {
  const bookRef = useRef();
  const glowRef = useRef();
  const timeRef = useRef(0);

  const handleOpen = useCallback(() => {
    if (onOpen) onOpen();
  }, [onOpen]);

  useFrame((_, delta) => {
    timeRef.current += delta;
    const t = timeRef.current;
    if (bookRef.current) {
      bookRef.current.rotation.y  = Math.sin(t * 0.4) * 0.12;
      bookRef.current.position.y = 1.52 + Math.sin(t * 1.1) * 0.03;
    }
    if (glowRef.current) {
      glowRef.current.material.opacity = 0.12 * (0.5 + Math.sin(t * 1.5) * 0.35);
    }
  });

  return (
    <group position={[0, 0, GUESTBOOK_Z]}>

      {/* ── Socle ── */}
      <mesh position={[0, 0.7, 0]}>
        <cylinderGeometry args={[0.38, 0.42, 1.4, 16]} />
        <meshStandardMaterial color="#2A2018" roughness={0.5} metalness={0.3} />
      </mesh>

      {/* ── Plateau doré ── */}
      <mesh position={[0, 1.42, 0]}>
        <cylinderGeometry args={[0.40, 0.40, 0.04, 16]} />
        <meshStandardMaterial color="#C9A84C" roughness={0.2} metalness={0.9} />
      </mesh>

      {/* ── Livre flottant ── */}
      <group ref={bookRef} position={[0, 1.55, 0]}>
        <mesh
          onClick={handleOpen}
          onPointerOver={() => { document.body.style.cursor = 'pointer'; }}
          onPointerOut={() => { document.body.style.cursor = 'default'; }}
        >
          <boxGeometry args={[0.42, 0.32, 0.06]} />
          <meshStandardMaterial color="#3D2810" roughness={0.6} metalness={0.15} />
        </mesh>
        <mesh position={[0, 0, 0.032]}>
          <planeGeometry args={[0.35, 0.26]} />
          <meshStandardMaterial
            color="#C9A84C" roughness={0.3} metalness={0.8}
            emissive="#C9A84C" emissiveIntensity={0.3}
          />
        </mesh>
      </group>

      {/* ── Grande zone de clic invisible (3m de diamètre × 3.5m de hauteur) ──
           Permet de cliquer sur l'autel de loin, surtout sur mobile */}
      <mesh
        position={[0, 1.5, 0]}
        onClick={handleOpen}
        onPointerOver={() => { document.body.style.cursor = 'pointer'; }}
        onPointerOut={() => { document.body.style.cursor = 'default'; }}
      >
        <cylinderGeometry args={[1.5, 1.5, 3.5, 16]} />
        <meshBasicMaterial transparent opacity={0} depthWrite={false} side={THREE.DoubleSide} />
      </mesh>

      {/* ── Halo de sol ── */}
      <mesh ref={glowRef} position={[0, 0.01, 0]} rotation={[-Math.PI / 2, 0, 0]}>
        <circleGeometry args={[1.2, 32]} />
        <meshBasicMaterial color="#C9A84C" transparent opacity={0.12} depthWrite={false} />
      </mesh>

      {/* ── Lumière ── */}
      <pointLight
        position={[0, 2.5, 0]}
        color="#FFE8A0"
        intensity={isNear ? 12 : 4}
        distance={6}
        decay={2}
      />

      {/* ── Billboard de proximité ── */}
      {isNear && (
        <Billboard follow>
          <mesh position={[0, 2.6, 0]}>
            <planeGeometry args={[1.6, 0.22]} />
            <meshBasicMaterial color="#1A1410" transparent opacity={0.75} depthWrite={false} />
          </mesh>
        </Billboard>
      )}

    </group>
  );
}
